import { get, sharedApi } from 'utils/api/api';

import { ConfirmResponse, Country } from 'types/commons';

import {
  CITIES,
  CITIES_BY_STATE_OR_COUNTRY,
  CONFIRM,
  COUNTRIES,
  FEEDBACK,
  STATES
} from 'constants/endpoints';

class CommonsService {
  async getCountries(locale: string): Promise<Country[]> {
    const response = await sharedApi.get(`${COUNTRIES}?locale=${locale}`);
    return response;
  }

  async getCitiesByCountryCodeAndSpelling(
    countryCode: string,
    spelling: string,
    lang: string
  ): Promise<string[]> {
    const response = await sharedApi.get(
      `${CITIES}?countryCode=${countryCode}&language=${lang}&search=${spelling}`
    );
    return response;
  }

  async getStatesByCountry(
    countryCode: string
  ): Promise<Record<string, string>[]> {
    const response = await sharedApi.get(
      `${STATES}?countryCode=${countryCode}`
    );
    return response;
  }

  async getCitiesByCountry(countryCode: string): Promise<string[]> {
    const response = await sharedApi.get(
      `${CITIES_BY_STATE_OR_COUNTRY}?countryCode=${countryCode}`
    );
    return response;
  }

  async getCitiesByState(state: string): Promise<string[]> {
    const response = await sharedApi.get(
      `${CITIES_BY_STATE_OR_COUNTRY}?state=${state}`
    );
    return response;
  }

  async getConfirmData(encryptedData: string): Promise<ConfirmResponse> {
    const response = await get(`${CONFIRM}?value=${encryptedData}`);
    return response;
  }

  async postFeedback(formData: FormData): Promise<void> {
    await sharedApi.postFormData(`${FEEDBACK}`, formData);
  }
}

export default new CommonsService();
